<template>
  <v-app>
    <v-card class="card-login mx-auto" max-width="440">
      <!-- Logo -->
      <v-layout>
        <v-flex xs12 class="text-lg-center logo-container">
          <v-img
            contain
            src="../assets/logo_login.png"
            max-height="120"
          ></v-img>
        </v-flex>
      </v-layout>

      <!-- Version -->
      <v-flex xs12 class="version-container text-center">
        <p
          class="version-text"
          @dblclick="atualizarApp()"
        >
          <v-icon small class="mr-1">mdi-information-outline</v-icon>
          v{{ app_version }}
        </p>
      </v-flex>

      <!-- Welcome Message -->
      <v-layout>
        <v-flex xs12 class="text-center welcome-section">
          <h2 class="welcome-title">Bem-vindo</h2>
          <p class="welcome-subtitle">Faça login para continuar</p>
        </v-flex>
      </v-layout>

      <!-- Error Alert -->
      <v-layout>
        <v-flex xs12 style="margin: 0 6% 16px 6%">
          <transition name="error-slide">
            <v-alert
              v-if="!dadosValidos"
              type="error"
              text
              dense
              dismissible
              class="modern-alert"
              @input="dadosValidos = true"
            >
              <div class="d-flex align-center">
                <v-icon small class="mr-2">mdi-alert-circle</v-icon>
                <span>{{ mensagemErro }}</span>
              </div>
            </v-alert>
          </transition>
        </v-flex>
      </v-layout>

      <!-- Email Field -->
      <v-layout>
        <v-flex xs12 class="text-lg-center" style="margin: 3% 6% 0% 6%">
          <v-text-field
            v-model="email"
            :error-messages="emailErrors"
            outlined
            label="Digite Email"
            prepend-inner-icon="mdi-email-outline"
            class="modern-input"
            @input="$v.email.$touch()"
            @blur="$v.email.$touch()"
          ></v-text-field>
        </v-flex>
      </v-layout>

      <!-- Password Field -->
      <v-layout>
        <v-flex xs12 class="text-lg-center" style="margin: 3% 6% 0% 6%">
          <v-text-field
            v-model.trim="password"
            :error-messages="passwordErrors"
            outlined
            label="Digite Senha"
            prepend-inner-icon="mdi-lock-outline"
            :type="show1 ? 'text' : 'password'"
            :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
            class="modern-input"
            @click:append="show1 = !show1"
            @input="$v.password.$touch()"
            @blur="$v.password.$touch()"
          ></v-text-field>
        </v-flex>
      </v-layout>
      <!-- Login Button -->
      <v-layout>
        <v-flex xs12 class="text-xs-center" style="margin: 24px 6% 0 6%">
          <v-btn
            block
            x-large
            elevation="8"
            class="modern-btn"
            :loading="loading"
            :disabled="loading"
            @click="verificarDadosLogin"
          >
            <span class="btn-text">Entrar</span>
            <v-icon right>mdi-login</v-icon>
            <template v-slot:loader>
              <span class="custom-loader">
                <v-icon>mdi-cached</v-icon>
                Verificando...
              </span>
            </template>
          </v-btn>
        </v-flex>
      </v-layout>

      <!-- Success Overlay -->
      <transition name="success-fade">
        <div v-if="loginSuccess" class="success-overlay">
          <div class="success-content">
            <v-icon size="80" color="white">mdi-check-circle</v-icon>
            <h3 class="success-text">Login realizado com sucesso!</h3>
            <v-progress-circular
              indeterminate
              color="white"
              size="40"
              class="mt-4"
            ></v-progress-circular>
          </div>
        </div>
      </transition>
    </v-card>
  </v-app>
</template>
<script>
import { required, email } from "vuelidate/lib/validators";
import UsuarioAPI from "./../api/usuario";
import DashboardAPI from "./../api/dashboard";
import { atualizarFlagsParceria } from "./../helpers";

export default {
  data() {
    return {
      show1: false,
      email: "",
      password: "",
      dadosValidos: true,
      mensagemErro: "",
      loading: false,
      loginSuccess: false,
      app_version: process.env.VUE_APP_VERSION,
    };
  },
  validations: {
    email: {
      required,
      email,
    },
    password: {
      required,
    },
  },

  computed: {
    passwordErrors() {
      const errors = [];
      if (!this.$v.password.$dirty) return errors;
      !this.$v.password.required && errors.push("Campo Obrigatório.");
      return errors;
    },
    emailErrors() {
      const errors = [];
      if (!this.$v.email.$dirty) return errors;
      !this.$v.email.required && errors.push("Campo Obrigatório.");
      !this.$v.email.email && errors.push("Email Inválido.");
      return errors;
    },
  },

  methods: {
    atualizarApp() {
      document.location.reload(true);
    },
    verificarDadosLogin() {
      if (!this.$v.$invalid) {
        this.login();
      }
    },
    getAcessos() {
      const headers = this.Helpers.iniciarRequisicao();

      UsuarioAPI.getAcessos(headers)
        .then((response) => {
          const token = response.data.token;
          localStorage.setItem("token", token);

          const acesso = localStorage.getItem("controle");
          const service = localStorage.getItem("service");

          if (response.status == 200) {
            if (response.data.acessos.length === 0) {
              alert("Usuário sem Permissão de Acesso!!!");
              this.Helpers.logout();
            } else {
              localStorage.setItem("urls", response.data.urls);

              // Espera o /me resolver para gravar parceira_ativa ANTES de redirecionar.
              // Sem isso, o TopBar da tela inicial monta sem a flag e fica em cache
              // (localStorage não é reativo no Vue 2).
              const redirecionar = () => {
                if (acesso == 5) {
                  this.$router.push({ name: "cadastro_pessoas" });
                } else if (acesso == 4) {
                  this.$router.push({ name: "cadastro_assessores" });
                } else if (acesso == 2 && service == "N") {
                  this.$router.push({ name: "dashboard_geral" });
                } else if (acesso == 2 && service == "S") {
                  this.$router.push({ name: "cadastro_candidatos" });
                } else {
                  this.$router.push("/dashboard");
                }
              };

              DashboardAPI.getValidateUser(this.Helpers.iniciarRequisicao())
                .then((meResp) => {
                  atualizarFlagsParceria(meResp.data.parceria);
                })
                .catch(() => {
                  atualizarFlagsParceria(null);
                })
                .finally(redirecionar);
            }
          }
        })
        .catch(() => {
          this.Helpers.logout();
        });
    },
    login() {
      this.loading = true;

      const headers = this.Helpers.iniciarRequisicao();

      const params = {
        email: this.email,
        password: this.password,
      };

      UsuarioAPI.login(headers, params)
        .then((response) => {
          this.loading = false;
          this.dadosValidos = true;
          this.loginSuccess = true;

          const token = response.data.token;
          localStorage.setItem("token", token);

          const user = Object.assign({}, response.data.user);

          localStorage.setItem("id", user.id);
          localStorage.setItem("nome", user.name);
          localStorage.setItem("service", user.service);
          localStorage.setItem("equipe", user.idgerente);
          localStorage.setItem("hash_acesso", user.hash_acesso);
          localStorage.setItem("controle", user.idperfil);

          setTimeout(() => {
            this.getAcessos();
          }, 800);
        })
        .catch((error) => {
          this.loading = false;
          this.dadosValidos = false;
          this.loginSuccess = false;
          switch (error.response.status) {
            case 401:
              this.mensagemErro = "Dados inválidos!";
              break;

            case 423:
              this.mensagemErro = "Sistema bloqueado para acesso. Procure o administrador.";
              break;

            default:
              this.mensagemErro = "Erro inesperado!";
              break;
          }
        });
    },
  },
};
</script>
<style scoped>
/* ========== VARIÁVEIS CSS ========== */
/*
 * As vars --cor-primaria* vêm do :root global, injetadas em main.js
 * conforme a equipe (VUE_APP_EQUIPE). Aqui ficam só as semânticas.
 */
:root {
  /* Cores de Suporte (não variam por equipe) */
  --white: #ffffff;
  --error-red: #ff5252;
  --success-green: #4caf50;
  --text-dark: #2c3e50;
}

/* ========== BACKGROUND ANIMADO ========== */
.theme--light.v-application {
  background: var(--cor-primaria-gradiente-animado);
  background-size: 400% 400%;
  animation: gradientShift 15s ease infinite;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
}

@keyframes gradientShift {
  0% { background-position: 0% 50%; }
  50% { background-position: 100% 50%; }
  100% { background-position: 0% 50%; }
}

/* Elementos Decorativos */
.theme--light.v-application::before {
  content: '';
  position: absolute;
  width: 500px;
  height: 500px;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 50%;
  top: -250px;
  right: -250px;
  animation: float 20s ease-in-out infinite;
}

.theme--light.v-application::after {
  content: '';
  position: absolute;
  width: 400px;
  height: 400px;
  background: rgba(255, 255, 255, 0.03);
  border-radius: 50%;
  bottom: -200px;
  left: -200px;
  animation: float 15s ease-in-out infinite reverse;
}

@keyframes float {
  0%, 100% { transform: translate(0, 0) rotate(0deg); }
  50% { transform: translate(50px, 50px) rotate(180deg); }
}

/* ========== CARD COM GLASSMORPHISM ========== */
.card-login {
  min-height: 420px;
  margin: 5vh auto;
  width: 90%;
  max-width: 440px;
  position: relative;

  /* Glassmorphism */
  background: rgba(255, 255, 255, 0.95) !important;
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);

  /* Bordas e Sombras */
  border-radius: 24px !important;
  border: 1px solid rgba(255, 255, 255, 0.4);
  box-shadow:
    0 8px 32px 0 rgba(0, 0, 0, 0.1),
    0 2px 8px 0 rgba(0, 0, 0, 0.05),
    inset 0 1px 0 rgba(255, 255, 255, 0.6);

  /* Padding */
  padding: 24px 24px !important;

  /* Animação */
  animation: fadeInUp 0.6s ease-out;
  transition: all 0.3s ease;
}

.card-login:hover {
  transform: translateY(-5px);
  box-shadow:
    0 16px 48px 0 rgba(0, 0, 0, 0.15),
    0 4px 16px 0 rgba(0, 0, 0, 0.08),
    inset 0 1px 0 rgba(255, 255, 255, 0.6);
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Responsividade para Mobile */
@media (max-width: 600px) {
  .card-login {
    width: 95%;
    margin: 2vh auto;
    padding: 20px 16px !important;
    border-radius: 20px !important;
  }

  .logo-container {
    margin: 0 0 8px 0;
  }

  .version-container {
    margin: 6px 0 8px 0;
  }

  .welcome-section {
    margin: 6px 0 12px 0;
  }
}

/* ========== LOGO ========== */
.logo-container {
  margin: 0 0 12px 0;
  animation: logoFadeIn 0.8s ease-out 0.2s both;
}

@keyframes logoFadeIn {
  from {
    opacity: 0;
    transform: scale(0.8) translateY(-20px);
  }
  to {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}

.logo-container .v-image {
  filter: drop-shadow(0 4px 12px rgba(var(--cor-primaria-rgb), 0.2));
  transition: all 0.3s ease;
}

.logo-container .v-image:hover {
  filter: drop-shadow(0 8px 20px rgba(var(--cor-primaria-rgb), 0.35));
  transform: scale(1.05);
}

/* ========== VERSÃO ========== */
.version-container {
  margin: 8px 0 12px 0;
  animation: fadeIn 0.8s ease-out 0.3s both;
}

.version-text {
  margin: 0;
  padding: 8px 16px;
  font-size: 13px;
  font-weight: 500;
  color: #9ca3af;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  border-radius: 20px;
  transition: all 0.3s ease;
  background: rgba(var(--cor-primaria-rgb), 0.05);
  border: 1px solid rgba(var(--cor-primaria-rgb), 0.1);
}

.version-text:hover {
  background: rgba(var(--cor-primaria-rgb), 0.1);
  color: var(--cor-primaria-dark);
  transform: scale(1.05);
}

.version-text .v-icon {
  color: var(--cor-primaria);
  opacity: 0.7;
}

/* ========== WELCOME SECTION ========== */
.welcome-section {
  margin: 8px 0 16px 0;
  animation: fadeIn 0.8s ease-out 0.4s both;
}

.welcome-title {
  font-size: 28px;
  font-weight: 600;
  color: var(--cor-primaria-dark);
  margin: 0 0 8px 0;
  letter-spacing: -0.5px;
}

.welcome-subtitle {
  font-size: 15px;
  font-weight: 400;
  color: #6b7280;
  margin: 0;
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

@media (max-width: 600px) {
  .welcome-title {
    font-size: 24px;
  }
  .welcome-subtitle {
    font-size: 14px;
  }
}

/* ========== INPUTS MODERNOS ========== */
.modern-input {
  animation: slideInRight 0.6s ease-out 0.5s both;
}

.modern-input >>> .v-input__control {
  border-radius: 12px !important;
}

.modern-input >>> .v-text-field__details {
  padding-left: 16px;
}

.modern-input >>> .v-input__slot {
  transition: all 0.3s ease !important;
  background: #fafafa !important;
}

.modern-input.v-input--is-focused >>> .v-input__slot {
  background: #ffffff !important;
  box-shadow:
    0 0 0 3px rgba(var(--cor-primaria-rgb), 0.1),
    0 4px 12px rgba(var(--cor-primaria-rgb), 0.15) !important;
  transform: translateY(-2px);
}

.modern-input.v-input--is-focused >>> .v-icon {
  color: var(--cor-primaria) !important;
}

.modern-input >>> fieldset {
  border-color: #e0e0e0 !important;
  border-width: 2px !important;
  transition: all 0.3s ease !important;
}

.modern-input.v-input--is-focused >>> fieldset {
  border-color: var(--cor-primaria) !important;
  border-width: 2px !important;
}

.modern-input:hover:not(.v-input--is-focused) >>> fieldset {
  border-color: var(--cor-primaria-light) !important;
}

.modern-input >>> label {
  font-weight: 500;
  color: #6b7280;
}

.modern-input.v-input--is-focused >>> label {
  color: var(--cor-primaria-dark) !important;
}

@keyframes slideInRight {
  from {
    opacity: 0;
    transform: translateX(-20px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

/* ========== ALERT DE ERRO ========== */
.modern-alert {
  border-radius: 12px !important;
  border-left: 4px solid #ff5252 !important;
  animation: shake 0.5s ease-in-out;
}

.error-slide-enter-active {
  animation: errorSlideDown 0.4s ease-out;
}

.error-slide-leave-active {
  animation: errorSlideUp 0.3s ease-in;
}

@keyframes errorSlideDown {
  from {
    opacity: 0;
    transform: translateY(-20px);
    max-height: 0;
  }
  to {
    opacity: 1;
    transform: translateY(0);
    max-height: 100px;
  }
}

@keyframes errorSlideUp {
  from {
    opacity: 1;
    transform: translateY(0);
    max-height: 100px;
  }
  to {
    opacity: 0;
    transform: translateY(-10px);
    max-height: 0;
  }
}

@keyframes shake {
  0%, 100% { transform: translateX(0); }
  10%, 30%, 50%, 70%, 90% { transform: translateX(-5px); }
  20%, 40%, 60%, 80% { transform: translateX(5px); }
}

/* ========== BOTÃO MODERNIZADO ========== */
.modern-btn {
  background: var(--cor-primaria-gradiente) !important;
  border-radius: 12px !important;
  height: 56px !important;
  text-transform: none !important;
  font-size: 16px !important;
  font-weight: 600 !important;
  letter-spacing: 0.5px !important;
  position: relative;
  overflow: hidden;
  animation: slideInUp 0.6s ease-out 0.6s both;
  transition: all 0.3s ease !important;
}

.modern-btn::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    90deg,
    transparent,
    rgba(255, 255, 255, 0.3),
    transparent
  );
  transition: left 0.5s ease;
}

.modern-btn:hover::before {
  left: 100%;
}

.modern-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 12px 28px rgba(var(--cor-primaria-rgb), 0.4) !important;
}

.modern-btn:active {
  transform: translateY(0);
}

.btn-text {
  color: white !important;
  font-weight: 600;
}

.modern-btn .v-icon {
  color: white !important;
}

.custom-loader {
  display: flex;
  align-items: center;
  gap: 8px;
  color: white;
}

.custom-loader .v-icon {
  animation: spin 1s linear infinite;
}

@keyframes spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

@keyframes slideInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.modern-btn.v-btn--disabled {
  background: #cccccc !important;
  opacity: 0.6;
}

@media (max-width: 600px) {
  .modern-btn {
    height: 52px !important;
    font-size: 15px !important;
  }
}

/* ========== SUCCESS OVERLAY ========== */
.success-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: var(--cor-primaria-gradiente);
  border-radius: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
}

.success-content {
  text-align: center;
  animation: successPulse 0.6s ease-out;
}

.success-text {
  color: white;
  margin-top: 16px;
  font-weight: 600;
  font-size: 20px;
}

.success-fade-enter-active {
  animation: successZoomIn 0.5s ease-out;
}

@keyframes successZoomIn {
  from {
    opacity: 0;
    transform: scale(0.8);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

@keyframes successPulse {
  0%, 100% { transform: scale(1); }
  50% { transform: scale(1.05); }
}

/* ========== ACESSIBILIDADE ========== */
.modern-input:focus-within >>> fieldset {
  outline: 2px solid var(--cor-primaria);
  outline-offset: 2px;
}

.modern-btn:focus {
  outline: 2px solid var(--cor-primaria-dark);
  outline-offset: 4px;
}

.modern-btn:focus:not(:focus-visible) {
  outline: none;
}

/* ========== RESPONSIVIDADE COMPLETA ========== */
@media (max-width: 960px) and (min-width: 601px) {
  .card-login {
    max-width: 420px;
    margin: 8vh auto;
  }
}

@media (max-height: 600px) {
  .card-login {
    margin: 2vh auto;
    min-height: auto;
  }

  .logo-container .v-image {
    max-height: 80px !important;
  }

  .welcome-section {
    margin: 8px 0 16px 0;
  }
}

@media (max-width: 360px) {
  .card-login {
    padding: 20px 12px !important;
  }

  .modern-btn {
    height: 48px !important;
    font-size: 14px !important;
  }
}
</style>
